// 用于二次封装企业微信api的工具函数
export default {
  sendChatMessage(options) {
    return new Promise((resolve, reject) => {
      ww.sendChatMessage({
        enterChat: true, // 为true时表示发送完成之后顺便进入会话
        ...options,
        success() {
          resolve();
        },
        fail() {
          reject();
        },
      });
    });
  },
};
